import * as en from "@/locales/en.po";
import { I18n, i18n } from "@lingui/core";
import { makeOnce } from "@warrenio/utils/makeOnce";

export const i18nDefaultOptions = {
    locale: "en",
    messages: { en: en.messages },
} as const;

// Always load the default "en" locale (otherwise messages will be completely missing)
i18n.load(i18nDefaultOptions.messages);
i18n.activate(i18nDefaultOptions.locale);

/** The default (English) {@link I18n} object. Use only as a fallback! */
export const getEnglishI18n = makeOnce(() => new I18n(i18nDefaultOptions));
